<script lang="ts" module>
  import { uniqueContext } from "#lib/internal/helpers"

  export type TooltipProviderProps = {
    delayDuration?: number
    skipDelayDuration?: number
    disableHoverableContent?: boolean
    children?: any
  }

  export type TooltipProviderContext = {
    readonly isOpenDelayed: boolean
    readonly delayDuration: number
    readonly onOpen: () => void
    readonly onClose: () => void
    readonly disableHoverableContent: boolean
    isPointerInTransit: boolean
  }

  const { getContext, setContext } = uniqueContext<TooltipProviderContext>()
  export const getTooltipProviderContext = getContext as () =>
    | TooltipProviderContext
    | undefined
</script>

<script lang="ts">
  import type { Snippet } from "svelte"

  type Props = TooltipProviderProps & { children?: Snippet }

  let {
    delayDuration = 300,
    skipDelayDuration = 300,
    disableHoverableContent = false,
    children,
  }: Props = $props()

  let skipDelayTimer = 0
  let isOpenDelayed: boolean = $state(true)
  let isPointerInTransit: boolean = $state(false)

  const handleOpen = () => {
    window.clearTimeout(skipDelayTimer)
    isOpenDelayed = false
  }

  const handleClose = () => {
    window.clearTimeout(skipDelayTimer)
    skipDelayTimer = window.setTimeout(() => {
      isOpenDelayed = true
    }, skipDelayDuration)
  }

  setContext({
    get isOpenDelayed() {
      return isOpenDelayed
    },
    get delayDuration() {
      return delayDuration
    },
    get onOpen() {
      return handleOpen
    },
    get onClose() {
      return handleClose
    },
    get disableHoverableContent() {
      return disableHoverableContent
    },
    get isPointerInTransit() {
      return isPointerInTransit
    },
    set isPointerInTransit(v) {
      isPointerInTransit = v
    },
  })
</script>

{@render children?.()}
